import React from 'react';
import { compose } from 'ramda';

import styleFile from './Icon.js';
import Image from '../Image';
import PropertyManager from '../../HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const Icon = class Icon extends React.Component {
  static displayName = 'Icon';
  render() {
    const { config, theme } = this.props;
    return (
      <Image
        config={{
          content: config.content,
          unicodeContent: config.unicodeContent,
          backgroundImage: config.backgroundImage,
          innerStyle: theme.computedInnerStyle,
          svg: config.svg,
          onClick: config.onClick,
          onMouseEnter: config.onMouseEnter
        }}
      />
    );
  }
};

export default compose(
  PropertyManager([
    'config',
    'src',
    'alt',
    'content',
    'unicodeContent',
    'backgroundImage',
    'svg',
    'onClick',
    'onMouseEnter'
  ]),
  withThemeJSS({ styleFile, link: true })
)(Icon);
